var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'list-item-upload-infinite': !_vm.loaded && !_vm.loading,
    'list-item-upload-progress': _vm.loading,
  },style:({ 'background-size': _vm.loading && (_vm.progress + "% 100%") })},[_vm._t("default",null,{"loaded":_vm.loaded,"loading":_vm.loading})],2)}
var staticRenderFns = []

export { render, staticRenderFns }